<template>
    <div class="add-to-cart-action frame-light-gray">
        <div class="row mb-3">
            <div :class="`col-lg-${12 / 1}`">
                <div class="d-flex align-items-strech justify-content-xs-left">
                    <span class="priceText">{{ $t('cart.price') }}:</span>
                    <span class="old-price">
                        <template v-if="product.is_discounted">
                            {{ product.brutto_price | money }}/{{ product.unit }}
                        </template>
                    </span>
                    <span class="price ml-lg-autot">{{ product.price | money }}/{{ product.unit }}<span class="text-salmon-strong" v-if="product.book == 1 || product.vele == 1">*</span></span>
                </div>
            </div>
        </div>
        <div v-if="product.stock >= product.min_order && product.active == 1" class="row">
            <div :class="`col-lg-${cols}`" v-if="cols == 12">
              <spinner
                  v-model="qty"
                  :value="product.min_order"
                  :step="product.step"
                  :min="product.min_order || 1"
                  :max="product.stock"
                  :precision="product.precision"
                  :unit="product.unit">
              </spinner>
              <br>
            </div>
            <div :class="`col-lg-5`" v-else>
              <spinner
                  v-model="qty"
                  :value="product.min_order"
                  :step="product.step"
                  :min="product.min_order || 1"
                  :max="product.stock"
                  :precision="product.precision"
                  :unit="product.unit">
              </spinner>
              <br>
            </div>
            <div :class="`col-lg-${cols} text-lg-left`">
                <div class="row">
                    <div class="col-lg-5 col-6">
                        <div class="input-group">
                            <input class="form-control" :value="total" disabled />
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-5 col-6 text-lg-right text-xs-left">
                        <button class="btn btn-green w-100" @click="addToCart" type="button">
                          <template v-if="loading">
                            <font-awesome-icon icon="spinner" spin size="xs"></font-awesome-icon>
                          </template>
                          <template v-else-if="added">
                            <font-awesome-icon icon="check"></font-awesome-icon>
                          </template>
                          <template v-else>
                            {{ $t('cart.add-to-cart')}} <span class="icon icon-shopping-cart"></span>
                          </template>
                        </button>
                        <div v-if="error" class="invalid-tooltip d-block">{{ error }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row">
          <div class="col-12">
            <div class="d-flex align-items-strech justify-content-xs-center">
              <em>{{ $t('cart.out-of-stock') }}</em>
            </div>
          </div>
          <div class="col-12 text-center mt-3" v-if="notifyadded">
            {{ $t('cart.out-of-stock-success') }}
          </div>
          <div class="col-12 text-center mt-3" v-else>
            <div class="form-group">
              <label for="email" class="control-label">{{ $t('cart.out-of-stock-email-text')}}</label> 
              <input type="email" v-model="notifyemail">
              <div class="error text-salmon-strong" v-if="notifyerror">
                {{ $t('cart.out-of-stock-empty-email') }}
              </div>
            </div>
            <button type="button" class="btn btn-green" @click="notifyMe">{{ $t('cart.out-of-stock-btn') }}</button>
          </div>
        </div>
    </div>
</template>

<script>
import Request from '@Core/xhr'
import { createNamespacedHelpers } from 'vuex'
import Spinner from '../common/Spinner'

const { mapActions } = createNamespacedHelpers('cart')

export default {

  components: {
    Spinner
  },

  props: {
    product: {
      required: true
    },
    cols: {
      default: 7
    },
    notifye: {
      default: ""
    }
  },

  data () {
    return {
      qty: this.product.default_qty || 1,
      loading: false,
      added: false,
      error: null,
      notifyemail: "",
      notifyerror: false,
      notifyadded: false
    }
  },

  computed: {
    total () {
      return (this.product.price * this.qty).toFixed(2).replace('.', ',') + ' €'
    }
  },

  methods: {

    ...mapActions(['addItem']),

    addToCart () {
      this.added = false
      this.loading = true

      this.addItem({
        id: this.product.id,
        qty: this.qty
      }).then(() => {
        this.error = null
        this.added = true
        this.loading = false

        setTimeout(() => {
          this.added = false
        }, 2000)
      }).catch((err) => {
        this.error = err.message
        setTimeout(() => { this.error = null }, 1500)
      })
    },

    notifyMe() {
        if(this.notifyemail != "") {
            let request = new Request(
              { 
                email: this.notifyemail,
                product_id: this.product.id
              });
            request.post('/cart/notifyMe').then((response) => {
                if(response ==  "Success") {
                  this.notifyadded = true;
                }
            })
        } else {
          this.notifyerror = true;
        }
    }
  },

  created () {
    this.notifyemail = this.notifye;
  },

  filters: {
    money (value) {
      return value.toFixed(2).replace('.', ',') + ' €'
    }
  }

}
</script>
